export default __webpack_public_path__ + "static/media/type-3.3a2d6847.svg";